import { render, staticRenderFns } from "./CoozzyExclamationTriangle.vue?vue&type=template&id=7d48f2cb&scoped=true"
import script from "./CoozzyExclamationTriangle.vue?vue&type=script&lang=js"
export * from "./CoozzyExclamationTriangle.vue?vue&type=script&lang=js"
import style0 from "./CoozzyExclamationTriangle.vue?vue&type=style&index=0&id=7d48f2cb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d48f2cb",
  null
  
)

export default component.exports